import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Wrench, RefreshCw, Sparkles } from 'lucide-react';
import { Toaster } from '../components/ui/toaster';

const Services = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <div className="bg-gray-50 py-16">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h1 className="text-4xl font-light text-gray-800 mb-4">Jewelry Services</h1>
          <p className="text-lg text-gray-600">
            Professional care for your precious jewelry
          </p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 py-16">
        {/* Ring Sizing */}
        <div className="mb-16">
          <div className="flex items-start gap-6">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0">
              <RefreshCw size={32} className="text-gray-700" />
            </div>
            <div className="flex-1">
              <h2 className="text-2xl font-light mb-4 text-gray-800">Ring Sizing</h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                We offer professional ring sizing services to ensure your jewelry fits perfectly. Whether you need to size up or down, our expert jewelers will carefully adjust your ring while maintaining its integrity and beauty.
              </p>
              <p className="text-gray-600"><strong>Turnaround:</strong> 2-3 weeks</p>
            </div>
          </div>
        </div>

        {/* Repairs */}
        <div className="mb-16">
          <div className="flex items-start gap-6">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0">
              <Wrench size={32} className="text-gray-700" />
            </div>
            <div className="flex-1">
              <h2 className="text-2xl font-light mb-4 text-gray-800">Repairs & Restoration</h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                From prong tightening to complete restorations, we provide comprehensive repair services. Our skilled craftspeople can restore your jewelry to its original beauty with meticulous attention to detail.
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-2 mb-4">
                <li>Prong repair and replacement</li>
                <li>Stone resetting</li>
                <li>Band repair</li>
                <li>Clasp replacement</li>
              </ul>
              <p className="text-gray-600"><strong>Turnaround:</strong> 3-4 weeks depending on service</p>
            </div>
          </div>
        </div>

        {/* Cleaning */}
        <div className="mb-16">
          <div className="flex items-start gap-6">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0">
              <Sparkles size={32} className="text-gray-700" />
            </div>
            <div className="flex-1">
              <h2 className="text-2xl font-light mb-4 text-gray-800">Professional Cleaning</h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Keep your jewelry sparkling with our professional cleaning services. We use ultrasonic cleaning and steam to restore the brilliance of your pieces.
              </p>
              <p className="text-gray-600"><strong>Complimentary</strong> for Diamond Q Jewelers customers</p>
            </div>
          </div>
        </div>

        {/* Contact CTA */}
        <div className="bg-gray-50 rounded-lg p-8 text-center">
          <h3 className="text-2xl font-light mb-4 text-gray-800">Ready to Service Your Jewelry?</h3>
          <p className="text-gray-600 mb-6">Contact us to schedule your service appointment</p>
          <div className="space-y-2">
            <p className="text-gray-700"><strong>Phone:</strong> 214-952-0001</p>
            <p className="text-gray-700"><strong>Email:</strong> dqkyukim@gmail.com</p>
          </div>
        </div>
      </div>

      <Footer />
      <Toaster />
    </div>
  );
};

export default Services;